import '../styles/globals.css';

import { GTM_ID, pageview } from 'lib/repository/gtm';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect } from 'react';
import { TrackingProvider } from '../lib/context/TrackingContext';

export default function App({ Component, pageProps }: AppProps): JSX.Element {
    const router = useRouter();
    useEffect(() => {
        router.events.on('routeChangeComplete', pageview);
        return () => {
            router.events.off('routeChangeComplete', pageview);
        };
    }, [router.events]);

    return (
        <TrackingProvider>
            {/* Google Tag Manager - Global base code */}
            <Script
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer', '${GTM_ID}');
        `
                }}
            />
            {/* GA4 script */}
            <Script async src={`https://www.googletagmanager.com/gtag/js?id=G-G9LY2L7G75`} />
            <Script
                strategy="beforeInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                  
                    gtag('config', 'G-G9LY2L7G75');
        `
                }}
            />
            <Component {...pageProps} />
        </TrackingProvider>
    );
}
